<template>
  <same-as :reference="reference"/>
</template>

<script>
import SameAs from './shbe_multiple_hb_or_cts';

export default {
  components: { SameAs },
  props: ['reference'],
}
</script>

